export default "__VITE_ASSET__4cif$7Lk__"